import React from 'react';
import { Alert, AlertDescription, AlertIcon, AlertTitle, Button, VStack } from '@chakra-ui/react';

export interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({
  title = 'Não foi possível carregar os dados',
  description = 'Verifique a conexão e tente novamente.',
  onRetry,
  retryLabel = 'Tentar novamente',
}: ErrorStateProps) {
  return (
    <Alert status="error" variant="left-accent" borderRadius="md" role="alert">
      <AlertIcon />
      <VStack align="flex-start" spacing={3} width="100%">
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription>{description}</AlertDescription>
        {onRetry && (
          <Button size="sm" colorScheme="red" variant="outline" onClick={onRetry}>
            {retryLabel}
          </Button>
        )}
      </VStack>
    </Alert>
  );
}
